
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import Switch from '@/components/switch.vue';
	import Message from '@/components/message.vue';
  import {
    activityTaskRewardactivityTaskRewardPageInit,
    activityTaskRewardactivityTaskRewardDelete,
    activityTaskRewardactivityTaskRewardIsOpenUpdate
  } from "@/api/live"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
			'slz-switch': Switch,
			'slz-message': Message,
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private state = null
    private statelist = [
      {value:null,label:'全部'},
      {value:0,label:'未开始'},
      {value:1,label:'进行中'},
      {value:2,label:'已结束'},
    ]
    private tablelist:any = []
    private tableloading = false
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
    private rowmsg:any = {}
    private delShow = false



    private mounted () {
      this.gettablelist()
    }


    private todata(row){
      this.$router.push({
        name:'TaskRewardData',
        query:{
          Id:row.Id,
          
        }
      })
    }
    private async confirmdel(){
      try{
        this.tableloading = true
        let res:any = await activityTaskRewardactivityTaskRewardDelete({
          Id:this.rowmsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.delShow = false
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private todel(row){
      this.rowmsg = row
      this.delShow = true
    }
    private async changeSwitch(e,row){
      try{
        this.tableloading = true
        let res:any = await activityTaskRewardactivityTaskRewardIsOpenUpdate({
          Id:row.Id,
          IsOpen:e
        })
        if(res.IsSuccess){
          this.gettablelist()
          this.$message.success('操作成功')
        }
      }finally{
        this.tableloading = false
      }
    }
    private todetails(row){
      this.$router.push({
        path:'TaskRewardDetails',
        query:{
          Id:row.Id,
        }
      })
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.keywords = ''
      this.state = null
      this.doSearch()
    }
    private changeCurrent(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await activityTaskRewardactivityTaskRewardPageInit({
          Keywords:this.keywords,
          State:this.state,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
